import React, { createContext, useContext, useState, useEffect } from 'react';

// Contexto global para el modo de vista
const ViewModeContext = createContext();

export const VIEW_MODES = {
  SIMPLE: 'simple',    // Para PYMEs - lenguaje amigable
  TECHNICAL: 'technical' // Para expertos - términos técnicos
};

export function ViewModeProvider({ children }) {
  const [viewMode, setViewMode] = useState(() => {
    const saved = localStorage.getItem('vektor_view_mode');
    return saved || VIEW_MODES.SIMPLE; // Por defecto modo simple para PYMEs
  });

  const [showOnboarding, setShowOnboarding] = useState(() => {
    return !localStorage.getItem('vektor_onboarding_completed');
  });

  useEffect(() => {
    localStorage.setItem('vektor_view_mode', viewMode);
  }, [viewMode]);

  const completeOnboarding = () => {
    localStorage.setItem('vektor_onboarding_completed', 'true');
    setShowOnboarding(false);
  };

  const resetOnboarding = () => {
    localStorage.removeItem('vektor_onboarding_completed');
    setShowOnboarding(true);
  };

  const isSimpleMode = viewMode === VIEW_MODES.SIMPLE;
  const isTechnicalMode = viewMode === VIEW_MODES.TECHNICAL;

  const toggleViewMode = () => {
    setViewMode(prev =>
      prev === VIEW_MODES.SIMPLE ? VIEW_MODES.TECHNICAL : VIEW_MODES.SIMPLE
    );
  };

  return (
    <ViewModeContext.Provider value={{
      viewMode,
      setViewMode,
      toggleViewMode,
      isSimpleMode,
      isTechnicalMode,
      showOnboarding,
      completeOnboarding,
      resetOnboarding
    }}>
      {children}
    </ViewModeContext.Provider>
  );
}

export function useViewMode() {
  const context = useContext(ViewModeContext);
  if (!context) {
    throw new Error('useViewMode must be used within a ViewModeProvider');
  }
  return context;
}

export default ViewModeContext;
